<script>
const token='';
const userinfo={};
const spbm='';
const  xsfname='';
const  xsfsbh='';
const xsfdz='';
const xsfkh='';
const agent=false;
const agentinfo={
 
};
const dailiinfo={};
  export default
  {
    
    token,//用户token身份
    userinfo,
    spbm,
    xsfname,
    xsfsbh,
    xsfdz,
    xsfkh,
    agent,
    agentinfo,
    dailiinfo,
  }
</script>


// WEBPACK FOOTER //
// src/components/Global.vue


// WEBPACK FOOTER //
// src/components/Global.vue